<div class="dropdown" ngbDropdown>
    <button class="btn btn-secondary dropdown-toggle"
            type="button" 
            ngbDropdownToggle
            data-test="import-domains-dropdown">
        <span translate>Import Domains</span>
    </button>
    <div class="dropdown-menu" ngbDropdownMenu>
        <button class="dropdown-item" 
                type="button"
                (click)="onCsvImport()" 
                data-test="import-csv-domains-item">
            <i class="fas fa-file-csv text-success fa-fw mr-2"></i>
            <span translate>Import from CSV</span>
        </button>
        <button class="dropdown-item" 
                type="button"
                (click)="onJsonImport()" 
                data-test="import-json-domains-item">
            <i class="fas fa-file-code text-primary fa-fw mr-2"></i>
            <span translate>Import from JSON</span>
        </button>
    </div>
</div>